import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LightningIcon',
  props: {
    scale: { default: 0.5 },
    width: { default: 27 },
    height: { default: 32 },
    title: { default: '' },
    fill: null,
    mode: { default: 'disabled' },
    type: { default: 'lightning' }
  },
  setup(__props: any, { emit }) {

const props = __props as { scale: number, width: number, height: number, title: string, fill?: string, mode: 'enabled' | 'disabled', type: 'lightning' | 'circular-lightning' | 'silver-lightning' };



const fill = computed(() => {
  if (props.fill) {
    return props.fill;
  } else if (props.mode === 'disabled') {
    return '#9E9E9E'; // grey
  } else {
    return '#7633FF'; // purple
  }
});

return { __sfc: true,emit, props, fill }
}

})